(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["froonze-customization"] && !Shopify.designMode) return;
  try {
    /* Account page enhancements:
   1. Phone number under the email (frcp.customerPage.profile.phone).
   2. Breadcrumbs above the page heading, driven by the URL hash.
   3. Tooltips for the text-less icon buttons on order cards.
   4. Larger, uncropped images on the Recently viewed cards.
   5. Collapsible order cards on mobile (arrow button, animated).
   6. Mobile logout proxy button (Safari clips the widget's own one).
   One MutationObserver re-applies all if the widget re-renders. */
(function () {
  var PHONE_CLASS = 'frcp-nav__phone';

  /* routes that get a breadcrumb; Orders (the default route) has none */
  var CRUMB_ROUTES = { profile: false, addresses: true, change_password: true };

  function getPhone() {
    try { return window.frcp.customerPage.profile.phone || ''; }
    catch (e) { return ''; }
  }

  function renderPhone() {
    var title = document.querySelector('.frcp-app .frcp-nav__title');
    if (!title) return;
    var phone = getPhone();
    var el = title.querySelector('.' + PHONE_CLASS);

    /* full email as tooltip (the text may be ellipsized by CSS) */
    var mail = title.querySelector('.frcp-nav__email');
    if (mail && mail.getAttribute('title') !== mail.textContent.trim()) mail.setAttribute('title', mail.textContent.trim());

    if (!phone) { if (el) el.remove(); return; }

    if (!el) {
      el = document.createElement('div');
      el.className = PHONE_CLASS;
      var email = title.querySelector('.frcp-nav__email');
      if (email) email.insertAdjacentElement('afterend', el);
      else title.appendChild(el);
    }
    if (el.textContent !== phone) el.textContent = phone;
    if (el.getAttribute('title') !== phone) el.setAttribute('title', phone);
  }

  /* current page label comes from the nav button, so it follows the widget's text */
  function navLabel(route) {
    var t = document.querySelector('.frcp-nav-button[data-to="#/' + route + '"] .frcp-nav-button__text');
    return t ? t.textContent.trim() : '';
  }

  function renderBreadcrumbs() {
    var view = document.querySelector('.frcp-app .frcp-main-view');
    if (!view) return;

    var route = location.hash.replace(/^#\/?/, '').split(/[\/?]/)[0] || 'orders';
    var el = view.querySelector(':scope > .frcp-breadcrumbs');

    if (!Object.prototype.hasOwnProperty.call(CRUMB_ROUTES, route)) {
      if (el) el.remove();
      return;
    }

    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var crumbs = [{ text: 'Home', href: root }, { text: 'My Account', href: '#/profile' }];
    if (CRUMB_ROUTES[route]) crumbs.push({ text: navLabel(route) });

    var key = route + '|' + crumbs.map(function (c) { return c.text; }).join('>');
    if (el && el.getAttribute('data-key') === key) return;

    if (!el) {
      el = document.createElement('nav');
      el.className = 'frcp-breadcrumbs';
      el.setAttribute('aria-label', 'Breadcrumb');
      view.insertBefore(el, view.firstChild);
    }
    el.setAttribute('data-key', key);
    el.textContent = '';

    var list = document.createElement('ol');
    list.className = 'frcp-breadcrumbs__list';
    crumbs.forEach(function (c, i) {
      var li = document.createElement('li');
      li.className = 'frcp-breadcrumbs__item';
      if (i === crumbs.length - 1) {
        li.setAttribute('aria-current', 'page');
        li.textContent = c.text;
      } else {
        var a = document.createElement('a');
        a.className = 'frcp-breadcrumbs__link';
        a.href = c.href;
        a.textContent = c.text;
        li.appendChild(a);
      }
      list.appendChild(li);
    });
    el.appendChild(list);
  }

  /* Order cards: the icon buttons have no visible text, so give them a tooltip /
     accessible name from the widget's own text (View details / Hide details /
     Download Invoice). */
  function renderOrderButtons() {
    document.querySelectorAll('.frcp-app .frcp-order').forEach(function (order) {
      var link = order.querySelector('.frcp-order__actions > a.frcp-order__btn');
      if (link) {
        var label = link.textContent.trim();
        if (label && link.getAttribute('aria-label') !== label) {
          link.setAttribute('aria-label', label);
          link.setAttribute('title', label);
        }
      }
      var toggle = order.querySelector('.frcp-order__expand-row');
      if (toggle) {
        var open = order.classList.contains('frcp-order--expanded');
        var el = toggle.querySelector(open ? '.frcp-order__hide-details' : '.frcp-order__view-details');
        var text = el ? el.textContent.trim() : '';
        if (text && toggle.getAttribute('title') !== text) toggle.setAttribute('title', text);
      }
    });
  }

  /* Recently viewed: the widget loads 250x200 cropped thumbnails, which look
     blurry and cut off in the larger cards. Swap to an uncropped 600px-wide image. */
  function renderProductImages() {
    document.querySelectorAll('.frcp-app .frcp-product__image').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      var next = src.replace(/_\d+x\d*(_crop_\w+)?(\.\w+)(\?|$)/, '_600x$2$3');
      if (next !== src) {
        img.setAttribute('src', next);
        img.removeAttribute('srcset');
      }
    });
  }

  /* Order cards (mobile): height of the items list, so the collapse can animate to
     a real value. 32 = the list's top + bottom padding when open. */
  function measureItems(order) {
    var list = order.querySelector('.frcp-order__line-item-container');
    if (!list || !list.children.length) return;
    var top = 1000000;
    var bottom = 0;
    var i;
    for (i = 0; i < list.children.length; i++) {
      top = Math.min(top, list.children[i].offsetTop);
      bottom = Math.max(bottom, list.children[i].offsetTop + list.children[i].offsetHeight);
    }
    var h = (bottom - top + 32) + 'px';
    if (list.style.getPropertyValue('--cm-items-h') !== h) list.style.setProperty('--cm-items-h', h);
  }

  /* Order cards (mobile): arrow button that shows or hides the order items and
     actions. State lives in a data attribute on the card so the widget cannot
     reset it. The button is hidden on desktop by CSS. */
  function renderItemsToggles() {
    document.querySelectorAll('.frcp-app .frcp-order').forEach(function (order) {
      var wrap = order.querySelector('.frcp-order__info-wrapper');
      if (!wrap) return;
      measureItems(order);
      var btn = wrap.querySelector('.frcp-order__items-toggle');
      var open = order.getAttribute('data-cm-items') === 'open';

      if (!btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'frcp-order__items-toggle';
        btn.addEventListener('click', function () {
          var card = btn.closest('.frcp-order');
          if (card.getAttribute('data-cm-items') === 'open') card.removeAttribute('data-cm-items');
          else card.setAttribute('data-cm-items', 'open');
          renderItemsToggles();
        });
        wrap.appendChild(btn);
      }

      var label = open ? 'Hide order items' : 'Show order items';
      if (btn.getAttribute('aria-expanded') !== String(open)) btn.setAttribute('aria-expanded', String(open));
      if (btn.getAttribute('aria-label') !== label) {
        btn.setAttribute('aria-label', label);
        btn.setAttribute('title', label);
      }
    });
  }

  /* Mobile logout: the widget's own button sits inside the scrolling tab menu, where
     Safari clips it if it is positioned absolutely. Add a proxy button directly under
     .frcp-nav that clicks the real one (kept in the DOM, hidden by CSS on mobile).
     NOTE: the widget also renders a hidden logout icon in .frcp-nav__mobile-logout (inside
     the title, hidden by the rule at the end of the stylesheet), so the real button is
     selected as .frcp-nav-button, never by the icon alone. */
  var LOGOUT_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false">' +
    '<rect x="7" y="0" width="17" height="24" rx="3.6" fill="#1e2754"/>' +
    '<rect x="0" y="3" width="11" height="18" rx="2.8" fill="#1e2754"/>' +
    '<path d="M5.9 12h9.4M5.9 12l3.1-3.1M5.9 12l3.1 3.1" fill="none" stroke="#f1f0fd" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function renderLogoutProxy() {
    var nav = document.querySelector('.frcp-app .frcp-nav');
    if (!nav) return;
    var proxy = nav.querySelector(':scope > .frcp-nav__logout-proxy');
    var real = nav.querySelector('.frcp-nav-button:has(> .frcp-icon[data-frcp-icon="logout"])');
    if (!real) { if (proxy) proxy.remove(); return; }

    if (!proxy) {
      proxy = document.createElement('button');
      proxy.type = 'button';
      proxy.className = 'frcp-nav__logout-proxy';
      proxy.innerHTML = LOGOUT_SVG;
      proxy.addEventListener('click', function () {
        var btn = nav.querySelector('.frcp-nav-button:has(> .frcp-icon[data-frcp-icon="logout"])');
        if (btn) btn.click();
      });
      nav.appendChild(proxy);
    }
    var label = real.getAttribute('aria-label') || real.textContent.trim() || 'Log out';
    if (proxy.getAttribute('aria-label') !== label) {
      proxy.setAttribute('aria-label', label);
      proxy.setAttribute('title', label);
    }
    if (!real.hasAttribute('data-cm-proxied')) real.setAttribute('data-cm-proxied', '');
  }

  function update() { renderLogoutProxy(); renderPhone(); renderBreadcrumbs(); renderOrderButtons(); renderProductImages(); renderItemsToggles(); }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
  window.addEventListener('hashchange', schedule);
  window.addEventListener('resize', schedule);
  update();
})();
  } catch(e) { console.error(e); }
})();

})();
